import { AnalyticsGraphBar1 } from '~/generated/svg/icon/AnalyticsGraphBar1';
import { ArrowLeft1 } from '~/generated/svg/icon/ArrowLeft1';
import { Calendar3 } from '~/generated/svg/icon/Calendar3';
import { CashPaymentBag1 } from '~/generated/svg/icon/CashPaymentBag1';
import type { Dictionary } from '~/shared/definitions/Dictionary';
import { GraphStatsAscend } from '~/generated/svg/icon/GraphStatsAscend';
import { LayoutDashboard1 } from '~/generated/svg/icon/LayoutDashboard1';
import { ListBullets } from '~/generated/svg/icon/ListBullets';
import { Icon as LogoIcon } from '~/generated/svg/logo/Icon';
import { MultipleActionsView } from '~/generated/svg/icon/MultipleActionsView';
import { PieLineGraphDesktop } from '~/generated/svg/icon/PieLineGraphDesktop';
import { QuestionHelpMessage } from '~/generated/svg/icon/QuestionHelpMessage';
import { RealEstateMarketCalculatorHouse } from '~/generated/svg/icon/RealEstateMarketCalculatorHouse';
import { RemoveCircle } from '~/generated/svg/icon/RemoveCircle';
import * as React from 'react';
import type { SVGProps } from 'react';
import { StyleOnePinHome } from '~/generated/svg/icon/StyleOnePinHome';
import { House } from '~/generated/svg/icon/House';
import { CursorClickStreamlineUltimate } from '~/generated/svg/icon/CursorClickStreamlineUltimate';
import { InformationCircle } from '~/generated/svg/icon/InformationCircle';
import { AppWindowUserStreamlineUltimate } from '~/generated/svg/icon/streamline-ultimate/AppWindowUserStreamlineUltimate';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { FileText as FileTextIcon } from 'lucide-react';

const iconMap: Dictionary<
  | React.ForwardRefExoticComponent<
      React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
        title?: string;
        titleId?: string;
      } & React.RefAttributes<SVGSVGElement>
    >
  | ((props: SVGProps<SVGSVGElement>) => JSX.Element)
> = {
  contact: QuestionHelpMessage,
  development: GraphStatsAscend,
  evaluation: RealEstateMarketCalculatorHouse,
  dossier: RealEstateMarketCalculatorHouse,
  home: House,
  dashboard: LayoutDashboard1,
  market: AnalyticsGraphBar1,
  region: StyleOnePinHome,
  logo: LogoIcon,
  arrowLeft1: ArrowLeft1,
  mulitpleActionsView: MultipleActionsView,
  listBullets: ListBullets,
  calendar3: Calendar3,
  cashPaymentBag1: CashPaymentBag1,
  pieLineGraphDesktop: PieLineGraphDesktop,
  demo: CursorClickStreamlineUltimate,
  info: InformationCircle,
  admin: AppWindowUserStreamlineUltimate,
  evaluations: RealEstateMarketCalculatorHouse,
  profile: InformationCircle,
  users: UserGroupIcon,
  // Immobilieninfo
  immobilieninfo: House,
  // File/document icon from lucide-react
  document: FileTextIcon,
  fileText: FileTextIcon,
  // Edit icon - using InformationCircle as fallback since no specific edit icon exists
  edit: InformationCircle,
};

interface Props extends SVGProps<SVGSVGElement> {
  readonly icon: string;
}

export function Icon(props: Props | any) {
  const Icon = iconMap[props.icon] || RemoveCircle;

  return <Icon {...props} />;
}
